/**
 * Shared config for the two public-facing Crunchy chat widgets:
 *  - MIGRATION: the MigrationCrunch guide/salesperson on /migrate pages
 *  - SALES:     the SalesCrunchCRM salesperson on marketing pages
 * Both render through MigrationConcierge/MigrationConciergeFloat — the
 * config swaps endpoints, copy, storage keys, and positioning.
 */

export const MIGRATION_CRUNCHY = {
  tid: 'migration',
  historyKey: 'mc_chat_history_v1',
  convKey: 'mc_chat_conv_v1',
  anonPath: '/api/ai/migration/chat-anon',
  authedPath: '/ai/migration/chat',
  headerTitle: 'Crunchy 🍿 · MigrationCrunch',
  headerSub: 'Ask anything · or say "show me a demo"',
  emptyBody:
    "I can walk you through a live demo, answer questions, or help you kick off a free 50-contact migration from any CRM to any CRM. What's on your mind?",
  suggestions: [
    'Show me a demo',
    'What CRMs can I migrate FROM and TO?',
    'What does the free 50-contact preview include?',
    'How much would it cost to migrate 5,000 contacts?',
  ],
  placeholder: 'Ask about your migration…',
  // Float widget
  peekSeenKey: 'mc_crunchy_peek_seen',
  peekTid: 'crunchy-peek',
  peekTitle: 'Hey — quick question, want me to help?',
  peekBody:
    "I'm Crunchy. I can walk you through a live demo, answer questions, or help you kick off a free 50-contact migration.",
  btnPos: 'bottom-36',
  peekPos: 'bottom-52',
  drawerPos: 'bottom-36',
};

export const SALES_CRUNCHY = {
  tid: 'crm-sales',
  historyKey: 'sc_sales_chat_history_v1',
  convKey: 'sc_sales_chat_conv_v1',
  anonPath: '/api/ai/crm/chat-anon',
  authedPath: null, // pre-sales widget — always anonymous
  headerTitle: 'Crunchy 🍿 · SalesCrunchCRM',
  headerSub: 'Your questions, answered by the AI that lives in the product',
  emptyBody:
    "I'm the salesperson here — but the kind that runs real numbers. Ask me why you'd switch from ACT!, what migration costs, or how the free trial works.",
  suggestions: [
    'Why should I switch from ACT!?',
    'Run the numbers vs Salesforce for my team',
    'How much to migrate 5,000 contacts?',
    'How does the 14-day free trial work?',
  ],
  placeholder: 'Ask about SalesCrunchCRM…',
  // Float widget
  peekSeenKey: 'sc_crunchy_peek_seen',
  peekTid: 'crm-sales-peek',
  peekTitle: 'Comparing CRMs? I can run the math.',
  peekBody:
    "I'm Crunchy — tell me your current CRM and team size and I'll show you exactly what you'd save. No email required.",
  btnPos: 'bottom-5',
  peekPos: 'bottom-24',
  drawerPos: 'bottom-5',
};
